

export class StaffDetailQuery {
    companyId: string;
    year: string;
    tipo: string;
    month: string;
    attribute: string;
    staffCount: string;
}